export function cookieInfo() {
    const cookie = $('.cookie-info');
    const header = $('.header');
    const main = $('.main');
    const closeCookie = cookie.find('.close');


    function setHeaderPosition() {
        if (sessionStorage.getItem('cookieAccess') === 'yes') {
            cookie.hide();
            main.removeAttr('style');
        } else {
            cookie.addClass("show");
            main.css('padding-top', header.innerHeight())
        }
    }

    setHeaderPosition();
    $(window).on('resize', function () {
        setHeaderPosition();
    });


    closeCookie.on("click", function (e) {
        e.preventDefault();
        sessionStorage.setItem('cookieAccess', 'yes');
        cookie.css("margin-top", -cookie.innerHeight());
        main.addClass('cookie-hide').removeAttr('style');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/cookieInfo.js